import type { VoidFunctionComponent } from 'react';
import ContentLoader from 'react-content-loader';

const TeamSelectionMenuLoading: VoidFunctionComponent = () => (
  <ContentLoader
    speed={2}
    width="100%"
    height={90}
    viewBox="0 0 300 90"
  >
    {/* mimic some rows of teams */}
    <rect x="0" y="0" rx="4" ry="4" width="100%" height="24" />
    <rect x="0" y="30" rx="4" ry="4" width="100%" height="24" />
    <rect x="0" y="60" rx="4" ry="4" width="100%" height="24" />
  </ContentLoader>
);

export default TeamSelectionMenuLoading;
